import { GridColumnVisibilityModel } from '@mui/x-data-grid-pro';
import * as React from 'react';

import { AddReferenceIdButton } from 'pages/Shipments/components/ContainerActions';
import { EditColumns } from './actions';
import {
  PortOfDestination,
  StatusFilter,
  MoreFilters,
  BillOfLading,
  ReferenceFilter,
} from './filters';
import { PresetView } from '../../types';
import { Bulk } from '../../Bulk';
import { Export } from '../../Actions';
import { translateVisibility, useWatchlistFilters } from '../../utilities';
import { Delete } from './actions/Delete';

interface Props {
  columnVisibilityModel: GridColumnVisibilityModel;
  onColumnVisibilityChange: (model: GridColumnVisibilityModel) => void;
  presetView: PresetView;
}

export const ActionBar: React.FC<Props> = (props) => {
  const { columnVisibilityModel, onColumnVisibilityChange, presetView } = props;

  const filters = useWatchlistFilters(presetView);
  const selectedColumns = React.useMemo(() => {
    return translateVisibility(columnVisibilityModel).map((e) =>
      e === 'reference_id' ? 'customer_id' : e
    );
  }, [columnVisibilityModel]);

  return (
    <div className="flex justify-between items-center gap-4 flex-wrap">
      <div className="flex space-x-4 items-center">
        <BillOfLading />
        <PortOfDestination />
        <StatusFilter presetView={presetView} />
        <ReferenceFilter />
        <MoreFilters />
      </div>
      <div className="flex space-x-4 items-center">
        <EditColumns
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityChange={onColumnVisibilityChange}
          presetView={presetView}
        />
        <Bulk>
          <Delete shouldDelete />
          <AddReferenceIdButton />
        </Bulk>
        <Export filters={filters} selectedColumns={selectedColumns} />
      </div>
    </div>
  );
};
ActionBar.displayName = 'Shipments.Containers.ActionBar';
